import { render } from "./VabeneReferralReportPage.vue?vue&type=template&id=7b744f16&ts=true"
import script from "./VabeneReferralReportPage.vue?vue&type=script&lang=ts"
export * from "./VabeneReferralReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__